var React = require('react');

function TrafficReports (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#7C8BDF;}\n"),React.createElement("path",{"fill":"currentColor","d":"M496,384H64V80c0-8.8-7.2-16-16-16H16C7.2,64,0,71.2,0,80v336c0,17.7,14.3,32,32,32h464c8.8,0,16-7.2,16-16v-32\n\tC512,391.2,504.8,384,496,384z M464,96H345.9c-21.4,0-32.1,25.8-17,41l32.4,32.4L288,242.8l-73.4-73.4c-12.5-12.5-32.8-12.5-45.2,0\n\tl-68.7,68.7c-6.2,6.2-6.2,16.4,0,22.6l22.6,22.6c6.2,6.2,16.4,6.2,22.6,0l46.1-46.1l73.4,73.4c12.5,12.5,32.8,12.5,45.2,0l96-96\n\tL439,247c15.1,15.1,41,4.4,41-17V112C480,103.2,472.8,96,464,96z","key":1})]);
}

TrafficReports.defaultProps = {"version":"1.1","id":"Layer_1","focusable":"false","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = TrafficReports;

TrafficReports.default = TrafficReports;
